import React from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import {
  Info, InfoContainer, TextContainer, Title,
} from './styles';
import ChallengeSubscriptionCard from '../../components/ChallengeSubscriptionCard';
import { ChallengeDetailType } from '../../types/Challenger';

interface Props {
  challengeDetail: ChallengeDetailType
}

export default function ChallengeSubscription({ challengeDetail }: Props) {
  const startDate = challengeDetail.startDate ? format(new Date(challengeDetail.startDate), "d 'de' MMMM 'de' yyyy", { locale: ptBR }) : null;
  const endDate = challengeDetail.endDate ? format(new Date(challengeDetail.endDate), "d 'de' MMMM 'de' yyyy", { locale: ptBR }) : null;
  return (
    <>
      <InfoContainer>
        <Info>{challengeDetail.description}</Info>
      </InfoContainer>
      <TextContainer>
        <Title>COMO COMPLETAR O DESAFIO?</Title>
        <Info>O Desafio vai sendo concluído a partir da soma das distâncias de suas atividades (corridas, caminhadas, pedaladas, natação, etc.).</Info>
        <Info>Você pode registrar as atividades direto na plataforma ou de forma automática, pelas integrações com relógios e outros aplicativos.</Info>
      </TextContainer>
      {challengeDetail.type === 'DATE' && startDate && endDate && (
        <TextContainer>
          <Title>Período de Participação</Title>
          <Info>{`O desafio estará disponível de ${startDate} até ${endDate}. Participe dentro desse período para conquistar sua medalha.`}</Info>
        </TextContainer>
      )}
      <ChallengeSubscriptionCard challengeDetail={challengeDetail} />
    </>
  );
}
